import React from "react";
import { useWindowSize } from "../../../hooks/hooks";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"];

function maxWordLen(s) {
  const length_of_label_text = s.split(" ").map((x) => x.length);
  const longest_label_length = length_of_label_text.reduce((a, b) =>
    Math.max(a, b)
  );
  return longest_label_length;
}

export default function VerticalBarChart(props) {
  const height =
    Math.max.apply(
      1,
      props.data.map((x) => x.name.split(" ").length)
    ) *
    props.data.length *
    26;

  return (
    <ResponsiveContainer width={"100%"} height={height + 50}>
      <BarChart
        data={props.data}
        layout="vertical"
        margin={{
          left:
            Math.max.apply(
              0,
              props.data.map((x) => maxWordLen(x.name))
            ) * 3,
        }}
      >
        <YAxis type="category" dataKey="name" />
        <XAxis type="number" />
        <Tooltip />
        <Bar
          dataKey={props.dataKey ? props.dataKey : "number"}
          fill={"#0072A7"}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
